import React from "react";
import Carousel from 'react-material-ui-carousel';
import { BACKEND_IMAGE_URL } from "../../services/Constants";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { IoLocationSharp } from "react-icons/io5";
import { PROFILE_IMAGE_PLACEHOLDER_KEY } from "../constants/Constants";

const ProfileImage = ({ profile, refreshCount = 0 }) => {
  const renderImage = (key, index) => {
    // Round timestamp to nearest 10 seconds
    let timestamp = Math.floor(new Date().getTime() / 10000) * 10000 + refreshCount;
    const imageUrl = index === -1 
      ? `${BACKEND_IMAGE_URL}/images/profile?userId=${profile.id}&timestamp=${timestamp}`
      : `${BACKEND_IMAGE_URL}/images/profile?photoKey=${key}&timestamp=${timestamp}`;
    
    return (
      <div key={index} className="w-full h-full aspect-[3/4] relative">
        <img
          className="w-full h-full rounded-lg object-cover"
          src={imageUrl}
          alt={`${profile.firstName} ${profile.lastName} - Photo ${index + 1}`}
        />
        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 text-white flex items-center justify-start gap-2 p-2">
          <IoLocationSharp />
          {profile.city && profile.city.charAt(0).toUpperCase() + profile.city.slice(1)}
        </div>
      </div>
    );
  };

  if (!profile.isImageAvailable) {
    return (
      <div className="w-full aspect-[3/4] flex items-center justify-center bg-gray-200 rounded-lg">
        <span className="text-gray-500">No photos available</span>
      </div>
    );
  }

  if (profile.photoKeys && profile.photoKeys.length > 0) {
    return (
      <div className="w-full aspect-[3/4]">
        <Carousel
          navButtonsAlwaysVisible={true}
          indicators={true}
          animation="fade"
          className="w-full h-full"
          navButtonsProps={{
            style: {
              display: profile.photoKeys.length <= 1 ? 'none' : 'flex'
            }
          }}
        >
          {profile.photoKeys.map((photoKey, index) => (
            <Link
              to={`/profile/${profile.id}`}
              key={index}
              className="w-full h-full flex items-center justify-center bg-gray-100 cursor-pointer"
              style={{ aspectRatio: '3/4', textDecoration: 'none' }}
            >
              {photoKey === PROFILE_IMAGE_PLACEHOLDER_KEY ? (
                <div className="w-full h-full aspect-[3/4] relative flex items-center justify-center bg-gray-100">
                  <Typography variant="body1" color="textSecondary">
                    Preview Mode
                  </Typography>
                  <div className="absolute bottom-0 w-full bg-black bg-opacity-50 text-white flex items-center justify-start gap-2 p-2">
                    <IoLocationSharp />
                    {profile.city && profile.city.charAt(0).toUpperCase() + profile.city.slice(1)}
                  </div>
                </div>
              ) : (
                renderImage(photoKey, index)
              )}
            </Link>
          ))}
        </Carousel>
      </div>
    );
  }

  // Fallback to single image using profile.id
  return (
    <Link to={`/profile/${profile.id}`} className="w-full h-full flex items-center justify-center bg-gray-100 cursor-pointer" style={{ aspectRatio: '3/4', textDecoration: 'none' }}>
      {renderImage(profile.id, -1)}
    </Link>
  );
};

export default ProfileImage; 